/* Ref: https://www.w3schools.com/js/js_cookies.asp */

function getCookie(cname) {
  let name = cname + "=";
  let decodedCookie = decodeURIComponent(document.cookie);
  let ca = decodedCookie.split(';');
  for(let i = 0; i <ca.length; i++) {
    let c = ca[i];
    while (c.charAt(0) == ' ') {
      c = c.substring(1);
    }
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return "";
}

/* Ref: https://www.w3schools.com/js/js_cookies.asp */

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + (exdays*24*60*60*1000));
  let expires = "expires="+ d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}

/* Ref: Howler */

function formatTime(secs) {
    var minutes = Math.floor(secs / 60) || 0;
    var seconds = (secs - minutes * 60) || 0;

    return minutes + ':' + (seconds < 10 ? '0' : '') + seconds;
}

// Abdelhady's Code

class Player {
  	constructor(playlist) {
    	this.playlist = playlist
        this.index = getCookie('ap-current-song') ? Number(getCookie('ap-current-song')) : 0
        this.volume = getCookie('ap-current-volume') ? parseFloat(getCookie('ap-current-volume')) : 1
        this.elapsed = getCookie('ap-current-elapsed') ? parseFloat(getCookie('ap-current-elapsed')) : 0
        this.autoplay = getCookie('ap-current-autoplay') ? (parseFloat(getCookie('ap-current-autoplay')) === 1 ? true : false) : false
        const trackElement = document.querySelector('#track')
        trackElement.textContent = `${this.index + 1}. ${playlist[this.index].title}`
        const fullBarElement = document.querySelector('#fullBar')
        const volumeSliderButtonElement = document.querySelector('#volumeSliderButton')
        fullBarElement.style.width = `${this.volume * 100}%`
        volumeSliderButtonElement.style.left = `${this.volume * 100}%`
        setCookie('ap-current-song', this.index, 1)
        setCookie('ap-current-volume', this.volume, 1)
        setCookie('ap-current-elapsed', this.elapsed, 1)
        setCookie('ap-current-autoplay', this.autoplay === true ? '1' : '0', 1)
  	}
  
    changeIndex = (newIndex) => {
        this.index = (newIndex >= this.playlist.length) ? (this.playlist.length - 1) : (newIndex < 0) ? 0 : newIndex
        setCookie('ap-current-song', this.index, 1)
        this.changeElapsed(0)
  	}
    
    changeVolume = (newVolume) => {
        if (typeof newVolume !== 'number' || newVolume > 1 || newVolume < 0) {
            return;
        }
        this.volume = newVolume
        setCookie('ap-current-volume', this.volume, 1)
        Howler.volume(newVolume)
        const fullBarElement = document.querySelector('#fullBar')
        const volumeSliderButtonElement = document.querySelector('#volumeSliderButton')
        fullBarElement.style.width = `${newVolume * 100}%`
        volumeSliderButtonElement.style.left = `${newVolume * 100}%`
  	}

    changeElapsed = (newElapsed) => {
        this.elapsed = newElapsed
        setCookie('ap-current-elapsed', this.elapsed, 1)
  	}

    changeAutoplay = (newAutoplay) => {
        this.autoplay = newAutoplay
        setCookie('ap-current-autoplay', this.autoplay === true ? '1' : '0', 1)
  	}
  
    play = () => {
      	const { title, howl, file } = this.playlist[this.index]
        let sound
        if (howl) {
        	sound = howl
        } else {
            sound = this.playlist[this.index].howl = new Howl({
              	src: file,
                autoplay: this.autoplay,
                mobileAutoEnable: true,
                volume: this.volume,
                html5: true,
                onplay: () => {
            		const durationElement = document.querySelector('#duration')
                    const pauseButtonElement = document.querySelector('#pauseButton')
                    const playButtonElement = document.querySelector('#playButton')
                    durationElement.textContent = formatTime(Math.round(sound.duration()))
                    pauseButtonElement.style.display = 'block'
                    playButtonElement.style.display = 'none'
                    this.changeAutoplay(true)
                    requestAnimationFrame(this.step)
            	},
                onplayerror: (v1, v2) => {
                    this.pause()
                },
                onend: () => {
                    pauseButtonElement.style.display = 'none'
                    playButtonElement.style.display = 'block'
                    this.changeAutoplay(false)
                    this.skip(true)
                },
                onpause: () => {
                    pauseButtonElement.style.display = 'none'
                    playButtonElement.style.display = 'block'
                    this.changeAutoplay(false)
                },
                onstop: () => {
                    pauseButtonElement.style.display = 'none'
                    playButtonElement.style.display = 'block'
                    this.changeAutoplay(false)
                }
            })
        }
        const id = sound.play()
        sound.seek(this.elapsed, id)
        const trackElement = document.querySelector('#track')
        trackElement.textContent = `${this.index + 1}. ${this.playlist[this.index].title}`
    }

    pause = () => {
        const sound = this.playlist[this.index].howl
        sound && sound.pause()
    }

    skip = (next = true) => {
        const sound = this.playlist[this.index].howl
        sound && sound.stop()
        if (next) {
            this.changeIndex(this.index + 1)
        } else {
            this.changeIndex(this.index - 1)
        }
        this.play()
    }

    toggleVolume = () => {
        const volumeWrapperElement = document.querySelector('.ap-volume-wrapper')
        volumeWrapperElement.style.display = volumeWrapperElement.style.display === 'block' ? 'none' : 'block'
    }

    seek = (elapsed, percent = false) => {
        const sound = this.playlist[this.index].howl
        const newElapsed = percent === false ? elapsed : (sound.duration() * elapsed)
        sound.seek(newElapsed)
        this.changeElapsed(newElapsed)
    }

    step = () => {
        const sound = this.playlist[this.index].howl
        const elapsed = this.elapsed
        const timerElement = document.querySelector('#timer')
        timerElement.textContent = formatTime(Math.round(elapsed))
        sound && (this.changeElapsed(sound.seek()))
        if (this.autoplay) {
            requestAnimationFrame(this.step)
        }
    }
}

let listOfSongs = []


	
	

	
    
       var song = {
        title: 'Blessings-Angel ft. French Montana, Davido',
        file: '//bezelled.com/cdn/shop/files/Angel_-_Blessings_REMIX_Audio_ft._French_Montana_Davido.mp3?v=2718343737486300047',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'SAVAGE Remix-Meg Thee Stallion & Queen Bey',
        file: '//bezelled.com/cdn/shop/files/Megan_Thee_Stallion_-_Savage_Remix_Clean_ft_Beyonce_KOTA.mp3?v=7863675546967335285',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'Winner-Zonnique',
        file: '//bezelled.com/cdn/shop/files/Zonnique_-_Winner_-_Lyrics_Clean.mp3?v=8193320431418605044',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'Doin My Dance-BBE AJ feat. BOOSIE',
        file: '//bezelled.com/cdn/shop/files/Doing_My_Dance_feat._Boosie_Badazz_Remix.mp3?v=7675357721231195292',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'Coffee-Kelly Rowland',
        file: '//bezelled.com/cdn/shop/files/Kelly_Rowland_-_Coffee_Clean_KOTA.mp3?v=6423242865607340547',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'Worth It-Lecrae feat. Kierra Sheard & Jawan Harris',
        file: '//bezelled.com/cdn/shop/files/Lecrae_ft._Kierra_Sheard_Jawan_Harris_-_Worth_It_Official_Audio.mp3?v=12033410769598846599',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
    
       var song = {
        title: 'I Need Your Love-Tink',
        file: '//bezelled.com/cdn/shop/files/I_Need_Your_Love_Clean_By_TInk.mp3?v=1232847440475663610',
        howl: null
    }               
    listOfSongs.push(song);           
                
                               

	
	

	
                               


const player = new Player(listOfSongs)
window.addEventListener('load', () => {
    if (player.autoplay === true) {
        player.play()
    }
})

const playButtonElement = document.querySelector('#playButton')
const pauseButtonElement = document.querySelector('#pauseButton')
const previousButtonElement = document.querySelector('#previousButton')
const nextButtonElement = document.querySelector('#nextButton')
const volumeToggleButtonElement = document.querySelector('#volumeToggleButton')
const emptyBarElement = document.querySelector('#emptyBar')
const volumeSliderButtonElement = document.querySelector('#volumeSliderButton')
const volumeWrapperElement = document.querySelector('.ap-volume-wrapper')
const apWrapperElement = document.querySelector('.ap-wrapper')

playButtonElement.addEventListener('click', () => player.play())
pauseButtonElement.addEventListener('click', () => player.pause())
previousButtonElement.addEventListener('click', () => player.skip(false))
nextButtonElement.addEventListener('click', () => player.skip(true))
volumeToggleButtonElement.addEventListener('click', () => player.toggleVolume())
volumeWrapperElement.addEventListener('click', () => player.toggleVolume())
emptyBarElement.addEventListener('click', (e) => {
    e = e || window.event
    player.changeVolume(e.offsetX / parseFloat(emptyBarElement.scrollWidth))
})

volumeSliderButtonElement.addEventListener('mousedown', () => window.sliderDown = true)
volumeSliderButtonElement.addEventListener('touchstart', () => window.sliderDown = true)
volumeWrapperElement.addEventListener('mouseup', () => window.sliderDown = false)
volumeWrapperElement.addEventListener('touchend', () => window.sliderDown = false)

const moveVolume = (e) => {
    e = e || window.event
    if (window.sliderDown === false) {
        return;
    }
    let x = e.clientX || e.touches[0].clientX
    const rect = e.currentTarget.getBoundingClientRect()
    x = x - rect.x
    const per = Math.min(1, Math.max(0, x / parseFloat(emptyBarElement.scrollWidth)))
    player.changeVolume(per)
}

volumeWrapperElement.addEventListener('mousemove', moveVolume)
volumeWrapperElement.addEventListener('touchmove', moveVolume)
